import gql from 'graphql-tag';

export const GET_LIVE_VIDEO = gql`
  query GetLiveVideo($uniqueId: String, $channelId: Int, $bitStreamType: Int) {
    getLiveVideo(
      uniqueId: $uniqueId
      channelId: $channelId
      bitStreamType: $bitStreamType
    ) {
      uniqueId
      url
      message
    }
  }
`;

export const GET_VEHICLE_DETAIL = gql`
  query GetVehicleDetail($id: String) {
    getVehicleDetail(deviceUniqueId_fk: $id) {
      vehicleNumber
      registrationNo
    }
  }
`;

export const GET_DEVICES_LIVE_DATA_VT_BY_UNIQUE_IDS = gql`
  query GetDevicesLiveDataVTByUniqueIds($uniqueIds: [String!]!) {
    getDevicesLiveDataVTByUniqueIds(uniqueIds: $uniqueIds) {
      uniqueId
      vehicleNumber
      deviceName
      deviceId
      status
      activeTime
      reportTime
      deviceTime
      address
      speed
      lat
      log
      clientId
    }
  }
`;

export const GET_DEVICES_CAM_COUNT_VT = gql`
  query getDevicesCamCountVT($uniqueIds: [String]!) {
    getDevicesCamCountVT(uniqueIds: $uniqueIds) {
      camCount
      uniqueId
      channels
      channelDescription {
        value
        label
      }
    }
  }
`;
